var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V12H10.32C10.1 11.33 10 10.66 10 10H4C4 8.9 3.11 8 2 8V4C3.11 4 4 3.11 4 2H14C14 3.11 14.9 4 16 4V4.06C16.67 4.06 17.34 4.18 18 4.4V0H0ZM9 3C7.3 3.03 6 4.3 6 6C6 7.7 7.3 8.94 9 9C9.38 9 9.77 8.92 10.14 8.77C10.41 7.67 10.86 6.63 11.97 5.61C11.85 4.28 10.59 2.97 9 3ZM18.63 6.27L14.76 10.17L13.41 8.8L12 10.22L14.75 13L20.03 7.68L18.63 6.27Z",
    fill: "#38A169"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashCheck);
export default __webpack_public_path__ + "static/media/cash-check.caba138b4355e8d9c10521fafebcd240.svg";
export { ForwardRef as ReactComponent };